import { useContext, useEffect } from "react";

import AutoLogout from "../../utils/useAutoLogout";

import PermissionContext from "../../context/PermissionContext";
import DrawerContext from "../../context/DrawerContext";
import MaterialsCaptureContext from "../../context/MaterialsCaptureContext";

import Box from '@mui/material/Box';

import PlateForm from "../../components/materialscapture/PlateForm";
import LipidForm from "../../components/materialscapture/LipidForm";
import BufferForm from "../../components/materialscapture/BufferForm1";
import AntibioticForm from "../../components/materialscapture/AntibioticForm";
// import PayloadPhaseForm1 from "../../components/materialscapture/PayloadPhaseForm1";
import EncapsulantPhaseForm from "../../components/materialscapture/EncapsulantPhaseForm1";
import MixingForm from "../../components/materialscapture/MixingForm1";
import IntermediateLNPSamplesForm from "../../components/materialscapture/IntermediateLNPSamplesForm";
import DilutionForm from "../../components/materialscapture/DilutionForm1";
import PurificationMethodForm from "../../components/materialscapture/PurificationMethodForm";
import AntibioticsAdditionForm from "../../components/materialscapture/AntibioticsAdditionForm";
import FinalLNPSamplesForm from "../../components/materialscapture/FinalLNPSamplesForm1";
import MaterialsCaptureSuccess from "../../components/materialscapture/MaterialsCaptureSuccess";
import MaterialsCaptureFooter from "../../components/materialscapture/MaterialsCaptureFooter";
import MaterialNoData from "../../components/materialscapture/MaterialNoData";

import SideDrawer from "../../components/layout/SideDrawer";
import PageHeader from "../../components/layout/PageHeader";
import ErrorModal from "../../components/layout/ErrorModal";
import SuccessAlert from "../../components/layout/SuccessAlert";
import Loader from "../../components/layout/Loader";
import CustomStepper from "../../components/layout/CustomStepper";

const MaterialsCapturePage = () => {
  const { permisionsList, checkUserPermission } = useContext(PermissionContext);
  const { drawerValue, setDrawerValue } = useContext(DrawerContext);
  const { 
    steps, stepIndex, materialsCaptureObj, apiRes, setApiRes, 
    handleSubmit, showFooter,
  } = useContext(MaterialsCaptureContext);

  useEffect(() => {
    if(permisionsList.length > 0) checkUserPermission(['Analytics-Import Data']);
  }, [permisionsList]);

  const lipidNoDataMsg = `Please select at least one Plate or 
    LNP Sample before adding or modifying lipids.`;

  return(
    <AutoLogout>
      {apiRes.loading && <Loader />}
      <SideDrawer drawerValue={drawerValue} setDrawerValue={setDrawerValue} />
      <div className="mainContainer" style={{ marginLeft: drawerValue.drawerWidth }}>
        {apiRes.showAlert && <SuccessAlert apiRes={apiRes} setApiRes={setApiRes} />}
        <PageHeader title={'Materials Capture'} />

        <CustomStepper steps={steps} stepIndex={stepIndex} />

        <Box sx={{ width: '100%', mb: 2 }}>
          <form onSubmit={handleSubmit}>
            {steps[stepIndex] === 'Lipids' && 
              (
                <>
                  {/* <FormulationPicker /> */}
                  <PlateForm />
                  { 
                    materialsCaptureObj?.lipidArray.map((data, index) => 
                      <LipidForm key={index} data={data} index={index} />
                    )
                  }
                  {
                    materialsCaptureObj?.lipidArray.length === 0 && 
                    <MaterialNoData message={lipidNoDataMsg} />
                  }
                </>
              )
            }

            {steps[stepIndex] === 'Buffers' && 
              materialsCaptureObj?.buffersArray.map((data, index) =>
                <BufferForm key={index} data={data} index={index} />
              )
            }

            {steps[stepIndex] === 'Antibiotics' && 
              materialsCaptureObj?.antibioticArray.map((data, index) =>
                <AntibioticForm key={index} data={data} index={index} />
              )
            }

            {/* {steps[stepIndex] === 'Payload Phase' && 
              materialsCaptureObj?.payloadPhaseArray.map((data, index) =>
                <PayloadPhaseForm1 key={index} data={data} index={index} />
              )
            } */}

            {steps[stepIndex] === 'Encapsulant Phase' && 
              materialsCaptureObj?.encapsulantPhaseArray.map((data, index) =>
                <EncapsulantPhaseForm key={index} data={data} index={index} />
              )
            }

            {steps[stepIndex] === 'Mixing' && 
              materialsCaptureObj?.mixingArray.map((data, index) =>
                <MixingForm key={index} data={data} index={index} />
              )
            }

            {steps[stepIndex] === 'Intermediate LNP Samples' && 
              materialsCaptureObj?.intermediateLnpSampleArray.map((data, index) =>
                <IntermediateLNPSamplesForm key={index} data={data} index={index} />
              )
            }

            {steps[stepIndex] === 'Dilution' && 
              materialsCaptureObj?.dilutionArray.map((data, index) =>
                <DilutionForm key={index} data={data} index={index} />
              )
            }

            {steps[stepIndex] === 'Purification' && 
              materialsCaptureObj?.purificationArray.map((data, index) =>
                <PurificationMethodForm key={index} data={data} index={index} />
              )
            }

            {steps[stepIndex] === 'Antibiotic Addition' && 
              materialsCaptureObj?.antibioticAdditionArray.map((data, index) =>
                <AntibioticsAdditionForm key={index} data={data} index={index} />
              )
            }

            {steps[stepIndex] === 'Final LNP Samples' && 
              materialsCaptureObj?.finalLNPSampleArray.map((data, index) =>
                <FinalLNPSamplesForm key={index} data={data} index={index} />
              )
            }

            {stepIndex === 11 && <MaterialsCaptureSuccess />}
          </form>

          {showFooter() && <MaterialsCaptureFooter />}
        </Box>

        <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />
      </div>
    </AutoLogout>
  );
};

export default MaterialsCapturePage;